import React from 'react';

const EmptyItems = ({ Icon, type, description, title, children, className }) => (
  <div className={`!mt-10 m-auto w-800px py-10 bg-white flex flex-col items-center rounded-md ${className || ''}`}>
    <Icon className="bg-flexi-info-toaster text-flexi-primary-color p-2 rounded-full mb-2"/>
    <p className="font-semibold">{title || `Aucune ${type} disponible`}</p>
    <div className="text-flexi-grey text-center">
      {children || (
        <>
          <p>Vous n'avez actuellement accès {description}.</p>
          <p>Contactez un administrateur pour obtenir un accès.</p>
        </>
      )}
    </div>
  </div>
);

export default EmptyItems;
